import { UniRoColumn } from "./Bit/UniRoColumn"
import { CartUpsellConfigSchema } from "./ConfigSchema/CartUpsellConfigSchema"

export const PluginsMap: any = {
    'bit-UniRoColumn': UniRoColumn,

    config: {
        cartUpsell: CartUpsellConfigSchema,
    }
}